import React, { useState } from 'react';
import styles from './styles.module.scss';

import { BlueButton, StyledButton } from 'components/Buttons';
import SelectInput from 'components/SelectInput/SelectInput';

import {
  usePicklistPermissions,
  usePicklistDetailsActions,
  usePicklistDetailsSelector
} from 'hooks/Picklist';
import { useMobileViewport } from 'hooks/useMobileViewport';

import CheckIcon from '@material-ui/icons/Check';

import { enrichNameToId } from 'helpers/AppHelpers';

import clsx from 'clsx';

import PicklistFilter from './PicklistFilter';

export function TableControls({
  onApply,
  onFilterApply,
  onDeleteSelectedAssets,
  chips,
  setChips,
  selectedRowIds
}) {
  const isMobile = useMobileViewport();

  const [status, setStatus] = useState({});

  const { criteria } = usePicklistDetailsSelector();
  const { picklistAssetStatuses } = criteria;

  const { checkBillOfLadingItemsAction } = usePicklistDetailsActions();
  const { isPicklistOpen, isCreateBoLAvailable, isRemovePicklistAssetAvailable } =
    usePicklistPermissions();

  const selectStatus = ({ value }) => setStatus(value);

  const applyStatus = () => {
    onApply(status);
    setStatus({});
  };

  const handleCreateBOLClick = () =>
    checkBillOfLadingItemsAction({ picklistAssetIds: selectedRowIds });

  const handleDeleteClick = () => onDeleteSelectedAssets();

  return (
    <div className={clsx(styles.wrapper, isPicklistOpen && !isMobile && styles.wrapped)}>
      <PicklistFilter onApply={onFilterApply} chips={chips} setChips={setChips} />

      {!!selectedRowIds?.length && (
        <div className={styles.controls}>
          {!isPicklistOpen && (
            <div className={styles.controls__editing}>
              <SelectInput
                name="status"
                value={status?.name || ''}
                menuItems={enrichNameToId(picklistAssetStatuses) || []}
                onSelect={selectStatus}
                className={styles.controls__select}
              />

              <StyledButton
                label={isMobile ? '' : 'Apply'}
                onClick={applyStatus}
                classes={clsx(styles.controls__btn, styles.apply)}>
                {isMobile && <CheckIcon />}
              </StyledButton>
            </div>
          )}

          <div className={styles.controls__buttons}>
            {isCreateBoLAvailable && (
              <BlueButton
                label="Create Bill of Lading"
                className={clsx(styles.controls__btn, styles.bol)}
                onClick={handleCreateBOLClick}
              />
            )}
            {isRemovePicklistAssetAvailable && (
              <BlueButton
                label="Delete All"
                className={clsx(styles.controls__btn, styles.delete)}
                onClick={handleDeleteClick}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
